"use client";

import { useEffect } from "react";

const RELOAD_FLAG = "__dom_error_reloaded_at";
const COOLDOWN_MS = 10000;

function matchesDomReconciliationError(message) {
  if (!message || typeof message !== "string") return false;
  return (
    message.includes("insertBefore") ||
    message.includes("removeChild") ||
    message.includes("is not a child of this node")
  );
}

function safeReload() {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_FLAG) || 0);
    if (Date.now() - last < COOLDOWN_MS) return;
    sessionStorage.setItem(RELOAD_FLAG, String(Date.now()));
  } catch (_) {}
  window.location.reload();
}

export default function DomErrorReloader() {
  useEffect(() => {
    const onError = (event) => {
      const message =
        event?.error?.message || event?.message || "";
      if (matchesDomReconciliationError(message)) {
        safeReload();
      }
    };

    const onUnhandledRejection = (event) => {
      const message =
        event?.reason?.message ||
        (typeof event?.reason === "string" ? event.reason : "");
      if (matchesDomReconciliationError(message)) {
        safeReload();
      }
    };

    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onUnhandledRejection);
    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onUnhandledRejection);
    };
  }, []);

  return null;
}
